module.exports = __webpack_public_path__ + "static/media/water-bg.61b19108.png";